<template>
    <section class="section">
        <div class="container" v-for="(chunks, name) in settings" :key="name">
            <h2 class="title is-5">{{ name }}</h2>
            <div class="columns" v-for="chunk in chunks" :key="chunk.id">
                <div class="column" v-for="setting in chunk" :key="setting.id">
                    <setting-obj :key="setting.key" :setting="setting" />
                </div>
                <div class="column" v-for="index in (columns - chunk.length)" :key="index"></div>
            </div>
            <hr>
        </div>
    </section>
</template>

<script>
import SettingObj from "./SettingObj"

export default {
    components: {
      SettingObj,
    },

    props: {
        settings: Object,
        columns: Number,
    }
}
</script>

<style scoped>
.container {
    margin-bottom: 36px;
}

.container >>> .label {
    height: 3.5em;
    padding-bottom: 0.5em;
    vertical-align: bottom;
    display: table-cell;
}
</style>
